export default {
  navigation: [
    { name: 'Acasă', href: '/' },
    { name: 'Servicii', href: '/services' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Despre noi', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ],
  languages: [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
  ],
  contact: {
    phone: '+41 77 218 45 02',
    email: 'info@alpbuild.ch',
    address: 'Elveția, cantonele Vaud și Geneva',
    whatsapp: '+41772184502',
    workingHours: 'Lun-Vin: 7:00-17:00'
  }
};